import { Component } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {
  HeadingTextWrapperComponent
} from "../../../shared/components/heading-text-wrapper/heading-text-wrapper.component";

@Component({
  selector: 'app-home-free-consultation',
  imports: [
    TranslatePipe,
    ButtonComponent,
    HeadingTextWrapperComponent
  ],
  templateUrl: './home-free-consultation.component.html',
  styleUrl: './home-free-consultation.component.scss'
})
export class HomeFreeConsultationComponent {

}
